'use client';

import { useEffect } from 'react';

import { client } from '../utils/trpc';

export default function GlobalError({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Report error to server (fire and forget)
    client.users.error
      .mutate({
        error: `Next.js Global Error: ${error.message}`,
        stack: error.stack || 'No stack trace',
        source: 'client'
      })
      .catch(() => {
        // Silently fail - can't do much if error reporting fails
      });
  }, [error]);

  return (
    <html>
      <body>
        <div className="flex min-h-screen items-center justify-center bg-background-primary">
          <div className="w-full max-w-md space-y-8">
            <div className="text-center">
              <h2 className="mt-6 text-3xl font-extrabold text-textPrimary">
                Something went wrong!
              </h2>
              <p className="mt-2 text-sm text-textSecondary">
                An unexpected error occurred. Please try again.
              </p>
              <div className="mt-5">
                <button
                  onClick={reset}
                  className="group relative flex w-full justify-center rounded-full border border-transparent bg-primary px-6 py-2.5 text-sm font-emphasis text-white hover:bg-indigo-400 focus:outline-none focus:ring-2 focus:ring-primary/20"
                >
                  Try again
                </button>
              </div>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
